import type { StationSectorRef } from '@/Network/Types/Responses/StationResponses'
import type { SpecialtySelection } from './sectorSpecialty'

/** Fora do prefixo `@ME:` de propósito: o 401 apaga só as chaves de auth (rule security-concerns). */
const KEY_PREFIX = 'minhaescala:last-sector-specialty:v1'

export type LastUsedSectorSpecialty = {
  sector: StationSectorRef | null
  specialty: SpecialtySelection | null
}

export const lastUsedKey = (userId: number, scheduleId: number): string =>
  `${KEY_PREFIX}:${userId}:${scheduleId}`

function toSector(value: unknown): StationSectorRef | null {
  if (!value || typeof value !== 'object') return null
  const sector = value as Record<string, unknown>
  return typeof sector.id === 'number' && typeof sector.name === 'string'
    ? { id: sector.id, name: sector.name }
    : null
}

function toSpecialty(value: unknown): SpecialtySelection | null {
  if (!value || typeof value !== 'object') return null
  const s = value as Record<string, unknown>
  if (s.kind === 'new')
    return typeof s.name === 'string' && s.name.trim() ? { kind: 'new', name: s.name } : null
  if (
    (s.kind === 'official' || s.kind === 'company') &&
    typeof s.id === 'number' &&
    typeof s.name === 'string'
  ) {
    return { kind: s.kind, id: s.id, name: s.name }
  }
  return null
}

export function readLastUsed(userId: number, scheduleId: number): LastUsedSectorSpecialty | null {
  if (!userId || !scheduleId) return null
  try {
    const raw = window.localStorage.getItem(lastUsedKey(userId, scheduleId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as Record<string, unknown>
    const sector = toSector(parsed.sector)
    const specialty = toSpecialty(parsed.specialty)
    return sector || specialty ? { sector, specialty } : null
  } catch {
    // fallback intencional: sugestão é conveniência (P2); sem storage o Criar funciona igual.
    return null
  }
}

export function writeLastUsed(
  userId: number,
  scheduleId: number,
  value: LastUsedSectorSpecialty
): void {
  if (!userId || !scheduleId || (!value.sector && !value.specialty)) return
  try {
    const previous = readLastUsed(userId, scheduleId)
    const next: LastUsedSectorSpecialty = {
      sector: value.sector
        ? { id: value.sector.id, name: value.sector.name }
        : (previous?.sector ?? null),
      specialty: value.specialty ?? previous?.specialty ?? null
    }
    window.localStorage.setItem(lastUsedKey(userId, scheduleId), JSON.stringify(next))
  } catch {
    // fallback intencional: sem storage a sugestão só não aparece da próxima vez.
  }
}
